import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { CallsLister } from '../../components/Calls';
import { NoCallSelectedEmptyState } from '../../components/EmptyStates';

import { useCallsPage } from './hooks/useCallsPage';

export const CallsPageContent = () => {
  useCallsPage();

  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.List>
          <CallsLister />
        </Layout.List>
        <Layout.Content>
          <NoCallSelectedEmptyState />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};
